














import { Vue, Component, Prop } from "vue-property-decorator";

// Enums
import { ProductTypes } from "@/data/enums/products";

// Types
import { IProduct } from "@/models/products";

@Component({
  components: {
    "edit-product-billing": () =>
      import(
        "@/components/app/admin/catalogue/products/billing/editProductBilling.vue"
      )
  }
})
export default class ProductBillingView extends Vue {
  @Prop({ required: true })
  public productId!: IProduct["id"];

  @Prop({ required: true })
  public productTypes!: number[];

  public get i18n() {
    return {
      title: this.productTypes.includes(ProductTypes.PRODUCT_OPTION)
        ? this.$t("_.product_option_billing")
        : this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE)
        ? this.$t("_.product_attribute_billing")
        : this.$t("_.product_billing")
    };
  }
}
